import * as React from 'react';
import './ChangeLogInfo.scss';
import { ChangeEntityLog, ChangeLog } from '../../models';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import { ChangeKind } from '../../models';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ChangeLogTable from '../ChangeLogTable.tsx';

export interface ChangeLogInfoProps {
    changeLog: (ChangeLog|ChangeEntityLog)[];
}

const ChangeLogInfo: React.FC<ChangeLogInfoProps> = ({
    changeLog,
}) => {

    const t = useTranslations();
    const latest = changeLog[0];

    const [modal, setModal] = React.useState(false);

    return (
        <>
            {latest && <p className="changeLogInfo" onClick={() => setModal(true)}>
                {
                    t(latest.changeKind === ChangeKind.Created 
                        ? TK.createdByAt
                        : TK.changedByAt,
                    latest.username,
                    latest.timestamp?.substring(0, 10))
                }
            </p>}
            <Modal isOpen={modal} toggle={() => setModal(!modal)} size="lg">
                <ModalHeader toggle={() => setModal(!modal)}>{t(TK.changeLog)}</ModalHeader>
                <ModalBody>
                    <ChangeLogTable changeLog={changeLog}/>
                </ModalBody>
            </Modal>
        </>
    );
}

export default ChangeLogInfo;